<template>
  <div id="staff-moment">
    <!--        :class="viewType === 'view' ? 'col-md-8' : 'col-md-12'"-->
    <div class="content-body-container">
      <div class="row" style="margin: 0px 5px 10px 5px">
        <div class="default-title-container">
          <i class="fa fa-th-large" style="color: #536170; margin-right: 10px; font-size: 20px"></i>
          <span class="sans-font-style-size-22" style="color: #536170">{{ lang('Moments') }}</span>
        </div>

        <div class="moments-action-button" style="margin-left: auto" v-if="userType !== 'Parent'">
          <button
            class="btn sans-font-style"
            style="border-radius: 5px 0px 0px 5px"
            @click="changeView('view')"
            :class="viewType === 'view' ? 'common-button' : ''"
          >
            {{ lang('Moments') }}
          </button>

          <!--                    border-radius: 0px 5px 5px 0px;-->
          <button
            v-if="!momentTourRunning"
            class="btn sans-font-style"
            style="border-radius: 0px 5px 5px 0px"
            @click="changeView('new')"
            :class="viewType === 'new' ? 'common-button' : ''"
          >
            {{ lang('New Moments') }}
          </button>

          <button
            v-if="momentTourRunning"
            class="btn sans-font-style"
            style="border-radius: 0px 5px 5px 0px"
            id="btnNewMoments"
            :class="viewType === 'new' ? 'common-button' : ''"
          >
            {{ lang('New Moments') }}
          </button>

          <!--                    v-if="viewType !== 'view'"-->
          <button
            v-if="!momentTourRunning"
            class="btn sans-font-style"
            style="border-radius: 0px 5px 5px 0px"
            @click="changeView('draft')"
            :class="viewType === 'draft' ? 'common-button' : ''"
          >
            {{ lang('Draft List') }}
          </button>

          <button
            v-if="momentTourRunning"
            class="btn sans-font-style"
            style="border-radius: 0px 5px 5px 0px"
            id="btnDraftList"
            :class="viewType === 'draft' ? 'common-button' : ''"
          >
            {{ lang('Draft List') }}
          </button>
        </div>
      </div>

      <div class="row" v-if="viewType === 'view'">
        <div class="parent-child-list" v-if="userType === 'Parent'">
          <button
            class="btn sans-font-style"
            style="font-size: 12px"
            @click="changePostsStatus('All')"
            :class="loadPostsMode === 'All' && studentID === '' ? 'common-button' : ''"
          >
            {{ lang('All Moments') }}
          </button>

          <!-- v-if="studInfo.StudentCourseStatus === 'Active'" -->
          <button
            class="btn sans-font-style"
            style="font-size: 12px"
            v-for="(studInfo, studIndex) in studentsInfo"
            @click="changePostsByStudent(studInfo)"
            :class="studentID === studInfo.StudentID ? 'common-button' : ''"
          >
            {{ studInfo.StudentFirstName }}
          </button>
        </div>

        <div class="divSelectStudent" v-if="userType === 'Course Leader' || userType === 'Pedagogy' || userType === 'Principal'">
          <div class="divSelectStudentLeft row">
            <div class="col-lg-6">
              <label class="searchAreaContentSelectClass">{{ lang('Select Class') }}</label>
              <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select" @change="LoadStudents()">
                <el-option
                  v-for="item in ddlClassList"
                  :key="item.PK_Class_ID"
                  :label="item.CLS_ClassName.trim() + ' ' + item.CLS_Batch.trim()"
                  :value="item.PK_Semester_ID.trim() + ',' + item.SC_FK_CourseID.trim() + ',' + item.PK_Class_ID.trim()"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-lg-6">
              <label class="searchAreaContentSelectStudent">{{ lang('Select Student') }}</label>
              <el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select" @change="LoadPortfolioByStudentID()">
                <el-option v-for="item in dllStudentList" :key="item.Student_ID" :label="item.Student_Name.trim()" :value="item.Student_ID"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="divSelectStudentRight"></div>
        </div>

        <div class="moments-list-container" v-if="momentList.length > 0">
          <div class="each-moments-container" @click="changeMomentPreview(mList)" v-for="mList in momentList" :class="mList.isActive ? 'active-preview' : ''">
            <div class="profile" style="vertical-align: top">
              <img src="../assets/boy.png" v-if="!mList.ProfileImage" />
              <img :src="`data:image/jpg;base64, ${mList.ProfileImage}`" v-if="mList.ProfileImage" />
            </div>

            <div class="moment-list-left-container" style="display: inline-block; width: calc(100% - 60px)">
              <div class="moments-created-details row" style="margin: 0px">
                <div>
                  <span class="sans-font-style-size-12 span-moments-name">{{ mList.CONname }}</span>
                </div>

                <div style="margin-left: auto">
                  <span class="sans-font-style-size-12 span-moments-date" style="font-size: 11px">{{ mList.PortfolioCreatedDate_convert }}</span>
                  <span
                    class="span-moment-download"
                    v-if="userType !== 'Parent'"
                    style="margin-left: 10px"
                    @click="deletePortfolio(mList.PortfolioID, mList.PortfolioTitle)"
                  >
                    <i class="fa fa-remove" aria-hidden="true"></i>
                  </span>
                </div>
              </div>

              <div class="moment-created-title row" style="margin: 0px">
                <div>
                  <span class="span-moments-title sans-font-style-size-12" style="font-weight: bold">{{ mList.PortfolioTitle }}</span>
                </div>

                <div style="margin-left: auto">
                  <span class="span-moment-download" @click="singleDownload(mList.PortfolioID)">
                    <i class="fa fa-download" aria-hidden="true"></i> {{ lang('Download') }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="moments-preview-container" v-if="!isNull(singleMoments)">
          <div class="col-12" style="background: #f8faff; text-align: left; padding: 10px; border-radius: 5px">
            <div class="profile">
              <img src="../assets/boy.png" v-if="!singleMoments.ProfileImage" />
              <img :src="`data:image/jpg;base64, ${singleMoments.ProfileImage}`" v-if="singleMoments.ProfileImage" />
            </div>

            <div class="feed-heading" style="vertical-align: middle">
              <span style="font-weight: normal">{{ singleMoments.CONname }}</span>
              <small class="date">
                {{ singleMoments.PortfolioCreatedDate_convert }}
              </small>
            </div>

            <div style="float: right">
              <button
                class="btn sans-font-style"
                @click="singleDownload(singleMoments.PortfolioID)"
                style="background: #426dff; border-radius: 5px; color: #ffffff"
              >
                {{ lang('Download') }}
              </button>
            </div>

            <div class="form-group">
              <div class="col-md-12 formDiv" style="padding: 10px 10px; background: #f8faff; text-align: left; border-radius: 5px">
                <p style="font-size: 14px; margin: 0px">
                  <span style="white-space: pre-line">{{ singleMoments.PortfolioTitle }}</span>
                </p>
              </div>
            </div>

            <div class="form-group" v-if="portfolioCommentHistoryList.length > 0">
              <div style="background: #e9edf7; padding: 10px 15px">
                <div v-for="momentComment in portfolioCommentHistoryList" style="margin-bottom: 5px">
                  <img src="../assets/Vector11.png" style="margin-right: 5px" />
                  <span class="sans-font-style" style="color: #19b600; vertical-align: middle">
                    {{ momentComment.CONname }} : {{ momentComment.AppComValue }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-12" style="padding: 0px">
            <div class="image-wrapper">
              <ul>
                <!--                                height: 300px;-->
                <li style="cursor: pointer" class="postFile__item">
                  <div style="width: 100%; height: 100%; overflow: auto; padding: 20px" @click="showImageModal(singleMoments)">
                    <pdf
                      class="nonM card-img-top d-block img-fluid"
                      v-for="i in singleMoments.numPages"
                      :key="i"
                      :src="singleMoments.pageOfSrc"
                      :page="i"
                      style="display: block; width: 100%"
                    >
                    </pdf>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="lds-ellipsis" v-if="isLoad">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <div class="empty-data" style="margin: 0 auto; position: relative" v-if="momentList.length <= 0 && !isLoad">
          <strong>{{ lang('Moments Not Found') }}</strong>
          <img src="../assets/notfound.png" />
        </div>
      </div>

      <div v-show="viewType !== 'view'">
        <portfolio :portFiles="selectedFiles" :paramPortfolio="portfolioID" :displayViewType="viewType" :passMomentTourData="momentTourType" />
      </div>
    </div>

    <b-modal id="imageModal" ref="imageModal" hide-footer hide-header>
      <b-carousel id="modal_carousel" style="text-shadow: 1px 1px 2px #333" indicators background="#fff" :interval="0">
        <div>
          <b-carousel-slide>
            <pdf v-if="!isNull(viewFiles)" v-for="i in viewFiles.numPages" :key="i" :page="i" style="display: block; width: 100%" :src="viewFiles.pageOfSrc">
            </pdf>
          </b-carousel-slide>
        </div>
      </b-carousel>
    </b-modal>

    <b-modal size="sm" title="Confirm Delete Moments" ok-only ok-variant="secondary" ok-title="Cancel" ref="changeStatusConfirmShowModal" hide-footer>
      <div class="row">
        <div class="col-lg-12">Confirm Delete Moments " {{ deletePortfolioTitle }} " ?</div>
        <div class="col-lg-12">
          <button v-on:click="updatePortfolio()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>

    <v-tour name="staffMomentTourName" :steps="staffMomentTour" :options="staffMomentTourOptions" :callbacks="staffMomentTourCallBacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour name="staffMomentEditTourName" :steps="staffMomentEditTour" :options="staffMomentEditTourOptions" :callbacks="staffMomentEditTourCallBacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Stop')">Skip</button>
                <button class="v-step__button" @click="momentTourNexPreviousStep(tour, 'Next')">Next</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import ProfileImg from '../assets/boy.png'
import { required, minLength } from 'vuelidate/lib/validators'
import { lang } from '../locale/index'
import $ from 'jquery'
import pdf from 'vue-pdf'

// import portfolio from "../pages/StaffPortfolio";
import portfolio from '../components/Portfolio_Component'

export default {
  name: 'StaffMoment',
  components: {
    portfolio,
    pdf,
  },
  data() {
    return {
      viewType: 'view',
      lastPortfolioID: '',
      selectedFiles: [],
      momentList: [],
      int_NumberOfPost: 5,
      isLoad: true,
      viewFiles: [],
      singleMoments: [],
      portfolioCommentHistoryList: [],
      parentInfo: [],
      studentsInfo: [],

      portfolioID: '',
      userType: '',
      studentID: '',

      loadPostsMode: '',

      deletePortfolioID: '',
      deletePortfolioTitle: '',

      ddlClass: '',
      ddlClassList: [],
      ddlStudent: '',
      dllStudentList: [],

      //vue tour
      momentTourType: '',
      momentTourRunning: false,

      staffMomentTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      staffMomentTourCallBacks: {
        // onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
        // onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps
      },
      staffMomentTour: [
        //Level Tab
        {
          target: '#btnNewMoments',
          content: `<div class="studentPageTourDiv">Step 1 / 6 <br>Select New Moments</div>`,
          params: {
            placement: 'top',
          },
        },
      ],

      staffMomentEditTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      staffMomentEditTourCallBacks: {
        // onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
        // onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps
      },
      staffMomentEditTour: [
        //Level Tab
        {
          target: '#btnDraftList',
          content: `<div class="studentPageTourDiv">Step 1 / 4 <br>Select Draft List</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      //vue tour
    }
  },
  created() {
    this.userType = Cookies.get('userTypeSession')

    if (this.userType === 'Parent') {
      this.LoadParentInfo()
      this.loadPostsMode = 'All'
    }
  },
  destroyed() {
    $(window).unbind('scroll')
  },
  mounted() {
    this.BindClasses()
    this.loadPortfolio()
    this.scrollToTop()

    const self = this

    if (this.$route.query.portfolioid !== undefined) {
      if (this.passPortfolioID !== '') {
        this.changeView('new')
        this.changeView('draft')
        this.portfolioID = this.passPortfolioID
      }
    }

    if (this.passTourData === 'moment' || this.passTourData === 'momentEdit') {
      this.momentTourRunning = true
      this.momentTourStart()
    }

    /*#region Scroll Loader Functions*/
    $(window).scroll(
      self.debounce(() => {
        if (self.getScrollPercent() >= 80 && self.momentList.length % 5 === 0 && self.momentList.length !== 0 && !self.isLoad) {
          this.isLoad = true

          let obj_LastPost = !this.isNull(this.momentList) ? this.momentList[this.momentList.length - 1] : ''
          let promise_GetPosts = DataSource.shared.getPortfolioMomentPost(this.int_NumberOfPost, obj_LastPost.PortfolioID, this.studentID)

          promise_GetPosts.then(response => {
            if (response.Table) {
              response.Table.forEach(file => {
                file.numPages = undefined

                if (file.FilePath) {
                  let src = pdf.createLoadingTask(file.FilePath)
                  file.pageOfSrc = src
                  src.promise.then(pdf => {
                    file.numPages = pdf.numPages
                  })
                }

                file.isActive = false
              })

              this.momentList.push.apply(this.momentList, response.Table)
            }
            this.isLoad = false
          })
        }
      }, 250),
    )
    /*#endregion*/
  },
  methods: {
    lang,

    async loadPortfolio() {
      this.$vs.loading()
      this.isLoad = true

      // this.isParent = Cookies.get('userTypeSession');
      this.momentList = []
      this.singleMoments = []

      const response = await DataSource.shared.getPortfolioMomentPost(this.int_NumberOfPost, this.lastPortfolioID, this.studentID)
      if (response) {
        if (response.code === '2') {
          // this.$notify.error({
          //     title: 'Error',
          //     message: 'No record found'
          // });
        } else if (response.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Please try again later',
          })
        } else {
          response.Table.forEach((file, index) => {
            file.numPages = undefined

            if (file.FilePath) {
              let src = pdf.createLoadingTask(file.FilePath)
              file.pageOfSrc = src
              src.promise.then(pdf => {
                file.numPages = pdf.numPages
              })
            }

            if (index === 0) {
              file.isActive = true
            } else {
              file.isActive = false
            }
          })

          this.momentList.push.apply(this.momentList, response.Table)

          if (this.momentList.length > 0) {
            this.changeMomentPreview(this.momentList[0])
          }
        }

        this.isLoad = false
      }

      this.$vs.loading.close()
    },

    showImageModal(pdfFiles) {
      this.viewFiles = []
      if (!this.isNull(pdfFiles)) {
        if (pdfFiles.FilePath) {
          let src = pdf.createLoadingTask(pdfFiles.FilePath)
          pdfFiles.pageOfSrc = src
          src.promise.then(pdf => {
            pdfFiles.numPages = pdf.numPages
          })
        }
        this.viewFiles = pdfFiles
      }
      this.$refs['imageModal'].show()
    },

    hideImageModal() {
      this.$refs['imageModal'].hide()
    },

    changeView(type) {
      this.viewType = type
    },

    changeMomentPreview(val) {
      this.singleMoments = []
      this.singleMoments = val
      this.getPortfolioComment(val.PortfolioID)

      this.momentList.forEach(momentItem => {
        if (momentItem.PortfolioID === val.PortfolioID) {
          momentItem.isActive = true
        } else {
          momentItem.isActive = false
        }
      })
    },

    singleDownload(portfolioID) {
      this.generatePortfolioPdf(portfolioID)
    },

    async getPortfolioComment(portfolioID) {
      try {
        const response = await DataSource.shared.getApproverComment(portfolioID)
        if (response) {
          if (response.code === '2') {
            console.log('Get Approver Comment: No Record')
          } else if (response.code === '99') {
            console.log('Get Approver Comment: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.portfolioCommentHistoryList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async generatePortfolioPdf(portfolioID) {
      try {
        this.$vs.loading()
        const response = await DataSource.shared.generatePortfolioPDF(portfolioID)
        if (response) {
          this.$vs.loading.close()

          var byteChar = atob(response)
          var byteNo = new Array(byteChar.length)
          for (var i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i)
          }

          var byteArray = new Uint8Array(byteNo)
          var file = new Blob([byteArray], { type: 'application/pdf;base64' })
          var fileUrl = URL.createObjectURL(file)

          window.open(fileUrl, '_blank', 'width=500, height=500')

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },

    async LoadParentInfo() {
      try {
        if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {
          const response = await DataSource.shared.getParentStudentsInfo(Cookies.get('userIDSession'))
          if (response) {
            if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No record found',
              })
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Please try again later',
              })
            } else {
              this.parentInfo = response.Parent[0]
              this.studentsInfo = response.Students
              // console.log(this.parentInfo, "parentInfo");
              // console.log(this.studentsInfo, "studentsInfo");
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    changePostsStatus(mode) {
      this.loadPostsMode = mode
      this.studentID = ''
      this.loadPortfolio()
    },

    changePostsByStudent(studInfo) {
      this.studentID = studInfo.StudentID
      this.loadPortfolio()
    },

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    },

    /*#region Scroll Loader Functions*/
    getScrollPercent() {
      //Credits to Phil Ricketts @ stackoverflow
      let height = document.documentElement,
        body = document.body,
        scrollTop = 'scrollTop',
        scrollHeight = 'scrollHeight'

      return ((height[scrollTop] || body[scrollTop]) / ((height[scrollHeight] || body[scrollHeight]) - height.clientHeight)) * 100
    },
    isScrollable() {
      return $(document).height() > $(window).height()
    },
    debounce(func, wait, immediate) {
      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.
      let timeout, result
      let self = this

      let later = function (context, args) {
        timeout = null
        if (args) result = func.apply(context, args)
      }

      let debounced = self.restArguments(function (args) {
        if (timeout) clearTimeout(timeout)
        if (immediate) {
          let callNow = !timeout
          timeout = setTimeout(later, wait)
          if (callNow) result = func.apply(this, args)
        } else {
          timeout = self.delay(later, wait, this, args)
        }

        return result
      })

      debounced.cancel = function () {
        clearTimeout(timeout)
        timeout = null
      }

      return debounced
    },
    delay(func, wait, ...args) {
      // Lodash Delay
      /**
       * Invokes `func` after `wait` milliseconds. Any additional arguments are
       * provided to `func` when it's invoked.
       *
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * delay(text => console.log(text), 1000, 'later')
       * // => Logs 'later' after one second.
       */
      if (typeof func != 'function') {
        throw new TypeError('Expected a function')
      }
      return setTimeout(func, +wait || 0, ...args)
    },
    restArguments(func, startIndex) {
      // Some functions take a variable number of arguments, or a few expected
      // arguments at the beginning and then a variable number of values to operate
      // on. This helper accumulates all remaining arguments past the function?s
      // argument length (or an explicit `startIndex`), into an array that becomes
      // the last argument. Similar to ES6?s "rest parameter".
      startIndex = startIndex == null ? func.length - 1 : +startIndex
      return function () {
        let length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0
        for (; index < length; index++) {
          rest[index] = arguments[index + startIndex]
        }
        switch (startIndex) {
          case 0:
            return func.call(this, rest)
          case 1:
            return func.call(this, arguments[0], rest)
          case 2:
            return func.call(this, arguments[0], arguments[1], rest)
        }
        let args = Array(startIndex + 1)
        for (index = 0; index < startIndex; index++) {
          args[index] = arguments[index]
        }
        args[startIndex] = rest
        return func.apply(this, args)
      }
    },
    /*#endregion*/

    deletePortfolio(potfolioID, potfolioTitle) {
      this.deletePortfolioID = ''
      this.deletePortfolioTitle = ''

      if (potfolioID !== '' && potfolioID !== null && potfolioID !== undefined) {
        this.deletePortfolioTitle = potfolioTitle
        this.deletePortfolioID = potfolioID
        this.$refs.changeStatusConfirmShowModal.show()
      }
    },

    async updatePortfolio() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.updatePortfolio(this.deletePortfolioID, 'Void')
        if (response) {
          if (response.code === '99') {
            console.log('Update Portfolio: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.$notify.success({
              title: 'Successful',
              message: 'Moments Deleted...',
            })

            this.$refs.changeStatusConfirmShowModal.hide()
            this.lastPortfolioID = ''
            this.loadPortfolio()
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    async BindClasses() {
      try {
        const response = await DataSource.shared.getAttendanceClass()
        if (response) {
          if (response.code === '2') {
            console.log('Get Attendance Class: No Record')
          } else if (response.code === '99') {
            console.log('Get Attendance Class: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.ddlClassList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async LoadStudents() {
      try {
        this.dllStudentList = []
        this.ddlStudent = ''

        this.$vs.loading()

        const response = await DataSource.shared.LoadAttendanceList(this.ddlClass)
        if (response) {
          if (response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'No Student Found...',
            })
          } else if (response.code === '99') {
            console.log('Load Attendance List: Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.dllStudentList = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    LoadPortfolioByStudentID() {
      this.studentID = this.ddlStudent
      this.lastPortfolioID = ''
      this.loadPortfolio()
    },

    momentTourStart() {
      if (this.passTourData === 'moment') {
        this.$tours['staffMomentTourName'].start()
      } else if (this.passTourData === 'momentEdit') {
        this.$tours['staffMomentEditTourName'].start()
      }
    },
    momentTourNexPreviousStep(tour, nextOrPreviousStep) {
      if (nextOrPreviousStep === 'Next') {
        tour.stop()
        this.momentTourRunning = false

        if (this.passTourData === 'moment') {
          this.changeView('new')
          this.momentTourType = 'momentTour'
        } else if (this.passTourData === 'momentEdit') {
          this.changeView('draft')
          this.momentTourType = 'momentEditTour'
        }
      } else if (nextOrPreviousStep === 'Stop') {
        tour.stop()
        this.momentTourRunning = false
      }
    },
  },
  filters: {},
  computed: {},
  validations: {},
  props: ['passSelectedFiles', 'passPortfolioID', 'passTourData'],
  watch: {
    passSelectedFiles: function (newVal, oldVal) {
      // watch it
      this.selectedFiles = oldVal

      if (newVal && newVal !== oldVal) {
        this.selectedFiles = newVal
      }
    },
    passPortfolioID: function (newVal, oldVal) {
      // watch it
      this.changeView('new')
      // this.changeView('draft');
      this.portfolioID = oldVal

      if (newVal && newVal !== oldVal) {
        this.portfolioID = newVal
      }
    },
  },
}
</script>

<style scoped>
.content-body-container {
  /*display: inline-block;*/
  margin: 0 auto;
  padding: 20px;
  /*background: white;*/
  /*background: #edf0f4;*/
}

::-webkit-input-placeholder {
  /* Edge */
  color: #91a3b6;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #91a3b6;
}

::placeholder {
  color: #91a3b6;
}

.empty-data strong {
  font-size: 30px;
  color: #90939a;
  z-index: 1;
  position: absolute;
  /*top: 20%;*/
  /*left: 50%;*/
  left: 20%;
  top: 5%;
}

.profile {
  width: 42px;
  height: 42px;
  margin-right: 10px;
}

.profile img {
  /*width: 50px;*/
  /*height: 50px;*/
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: contain;
}

.image-wrapper {
  background: #e1e6f0;
  width: 100%;
  /*height: 300px;*/
}

.moments-list-container {
  width: 50%;
  padding: 20px;
}

.mobile-view .moments-list-container {
  width: 100%;
  padding: 20px;
}

.moments-preview-container {
  width: 50%;
  padding: 20px;
  margin-left: auto;
  position: sticky;
  top: 0px;
  align-self: flex-start;
  /*min-height: 90vh;*/
  /*max-height: 93vh;*/
  min-height: calc(100vh - 85px);
  max-height: 100%;
}

.mobile-view .moments-preview-container {
  width: 100%;
}

.moments-action-button button {
  background: #91a3b6;
  color: #ffffff;
  padding: 6px 20px;
}

.moments-action-button button.common-button {
  background: #426dff;
}

.each-moments-container {
  margin-bottom: 10px;
  background: #f8faff;
  border-radius: 3px;
  text-align: left;
  padding: 10px;
  cursor: pointer;
}

.each-moments-container.active-preview {
  background: #426dff;
}

.each-moments-container.active-preview .span-moments-name,
.each-moments-container.active-preview .span-moments-date,
.each-moments-container.active-preview .span-moments-title,
.each-moments-container.active-preview .span-moment-download {
  color: #ffffff;
}

.span-moments-name {
  color: #4f4f4f;
}

.span-moments-date {
  color: #9e9e9e;
}

.span-moments-title {
  white-space: pre-line;
  color: #4f4f4f;
}

.span-moment-download {
  color: #426dff;
}

.parent-child-list {
  text-align: left;
  width: 100%;
  padding: 0px 20px;
}

.parent-child-list button {
  background: #91a3b6;
  color: #ffffff;
  padding: 6px 20px;
}

.parent-child-list button.common-button {
  background: #426dff;
}

.mobile-view .parent-child-list {
  text-align: left;
}

.mobile-view .parent-child-list button {
  background: #d3d9e8;
  color: #536170;
  padding: 6px 20px;
}

.mobile-view .parent-child-list button.common-button {
  background: #ffffff;
  color: #426dff;
}

.sans-font-style-size-12 {
  font-family: sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
}

.sans-font-style {
  font-family: sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}

.sans-font-style-size-22 {
  font-family: sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 28px;
}

.divSelectStudent {
  width: 100%;
  padding: 20px;
}

.divSelectStudentLeft,
.divSelectStudentRight {
  width: 50%;
  float: left;
}

.divSelectStudentLeft {
  background-color: white;
  border-radius: 3px;
  padding: 20px;
  cursor: pointer;
}
</style>

<style>
#imageModal .carousel-item {
  height: calc(100vh - 100px);
}

#imageModal .carousel-caption {
  position: unset;
  max-height: 100%;
  overflow: auto;
}

#staff-moment .image-wrapper li.postFile__item:first-child,
#staff-moment .image-wrapper li.postFile__item {
  height: 400px;
  /*height: 100%;*/
  /*height: auto;*/
}
</style>
